import { useContext } from 'react';

import { EmbeddedWidgetContext, EmbeddedWidgetContextType } from '../embedded-widget-context';

const useEmbeddedWidgetContext = <T>() => {
  const context = useContext(EmbeddedWidgetContext);
  if (context === undefined) {
    throw new Error('This hook must be used within the EmbeddedWidgetProvider');
  }
  return context as EmbeddedWidgetContextType<T>;
};

export default useEmbeddedWidgetContext;
